import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { BadgeCheckIcon, XIcon } from "lucide-react";
import { buyers } from "../data/buyers";
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    let showTimer: ReturnType<typeof setTimeout>;
    const cycle = (delay: number) => {
      showTimer = setTimeout(() => {
        setVisible(true);
        hideTimer = setTimeout(() => {
          setVisible(false);
          setIndex(i => (i + 1) % buyers.length);
          cycle(GAP);
        }, VISIBLE_FOR);
      }, delay);
    };
    cycle(FIRST_DELAY);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const buyer = buyers[index];
  const initials = buyer.name.split(" ").map(p => p[0]).join("").slice(0, 2);
  return <div className="pointer-events-none fixed bottom-[92px] left-3 right-3 z-50 sm:left-5 sm:right-auto sm:w-[340px]" aria-live="polite" data-id="element-267" data-mp="116mhkvlo2u6k">
      <AnimatePresence data-id="element-268" data-mp="1awzbvfjaa1pw">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-center gap-3 rounded-2xl bg-white p-3 pr-9 shadow-[0_12px_40px_rgba(6,20,43,0.35)] ring-1 ring-navy-950/10" data-id="element-269" data-mp="1axhceoczb23m">
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-navy-900 font-display text-sm font-extrabold text-accent" data-id="element-270" data-mp="28jes6dzz4tbv">
              {initials}
            </div>
            <div className="min-w-0 text-left" data-id="element-271" data-mp="2apctl5hq1bkk">
              <p className="text-[13px] leading-snug text-ink" data-id="element-272" data-mp="2aqnxr6f2wlc7">
                <strong data-id="element-273" data-mp="2fmcw56fd3w6x">{buyer.name}</strong> from <strong data-id="element-274" data-mp="2fph9atat229q">{buyer.country}</strong> just purchased the GI Nutrition Clinical Blueprint™
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[11px] font-semibold text-after" data-id="element-275" data-mp="2plu4jvm00o6l">
                <BadgeCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-276" data-mp="1ry3dgddg3ok0" />
                Verified purchase · {buyer.time}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} className="absolute right-2 top-2 rounded-full p-1 text-muted transition-colors duration-150 hover:bg-paper hover:text-ink" aria-label="Dismiss notification" data-id="element-277" data-mp="1wxoin5j7kt56">
              <XIcon className="h-3.5 w-3.5" data-id="element-278" data-mp="1972gtvzss53m" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}